import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/coursewares/video_courseware.png'
import _imports_1 from '@/assets/coursewares/popularity.png'
import _imports_2 from '@/assets/coursewares/download.png'


_pushScopeId("data-v-73f1278e")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "courseware_icon",
  src: _imports_0
}, null, -1)
const _hoisted_2 = { style: {"padding-left":"5px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"padding-left":"7px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "popularity",
  src: _imports_1
}, null, -1)
const _hoisted_6 = { style: {"padding-left":"5px"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "download",
  src: _imports_2
}, null, -1)
const _hoisted_8 = { style: {"padding-left":"5px"} }
_popScopeId()

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_col = _resolveComponent("a-col")
  const _component_card_name_title = _resolveComponent("card-name-title")
  const _component_user_outlined = _resolveComponent("user-outlined")
  const _component_a_tooltip = _resolveComponent("a-tooltip")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock(_component_a_card, { class: "card_body" }, {
    actions: _withCtx(() => [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = (...args) => ($setup.handlePreview && $setup.handlePreview(...args)))
      }, "预览"),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = (...args) => ($setup.handleShowWarning && $setup.handleShowWarning(...args)))
      }, "获取")
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_row, {
        gutter: [16, 16],
        onClick: $setup.handlePreview
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 18 }, {
            default: _withCtx(() => [
              _createVNode(_component_card_name_title, {
                type: "视频",
                name: $setup.coursewareName
              }, null, 8, ["name"]),
              _createElementVNode("div", null, [
                _createVNode(_component_user_outlined),
                _createElementVNode("span", _hoisted_2, [
                  ($setup.coursewareInfo.author_name.length < 4)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.coursewareInfo.author_name), 1))
                    : (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 1,
                        title: $setup.coursewareInfo.author_name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.coursewareInfo.author_name.slice(0, 3)) + "... ", 1)
                        ]),
                        _: 1
                      }, 8, ["title"]))
                ]),
                _createElementVNode("span", _hoisted_4, _toDisplayString($setup.coursewareInfo.created_at), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString($setup.coursewareInfo?.popularity?.popularity || 0), 1),
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString($setup.coursewareInfo?.popularity?.download_num || 0), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}